import React, { useState } from "react";
import { StatusBar } from "expo-status-bar";
import { SafeAreaProvider } from "react-native-safe-area-context";

import ActorsRegistryPage from "./src/pages/ActorsRegistryPage";
import ProductDossierPage from "./src/pages/ProductDossierPage";

export default function App() {
  const [currentPage, setCurrentPage] = useState("actors");

  return (
    <SafeAreaProvider>
      <StatusBar style="light" />
      {currentPage === "actors" ? (
        <ActorsRegistryPage
          onOpenProductDossier={() => setCurrentPage("productDossier")}
        />
      ) : (
        <ProductDossierPage goBack={() => setCurrentPage("actors")} />
      )}
    </SafeAreaProvider>
  );
}